import React, { Component } from "react";
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Grid, Header, Icon, Table } from 'semantic-ui-react';
import styled from 'styled-components';
import { EpPrivilege } from 'ts-types/api.enums';

const StyledIcon = styled(Icon)`
    cursor: pointer;
`;

const StyledBtnContainer = styled.div`
  margin-bottom: 5px;
  white-space: nowrap !important;
`;

const StyledButtons = styled(Grid.Column)`
  padding: 0 !important;
  margin: 0 0 0 4px !important;
  flex: 1 1 auto;
`;

const StyledTableRight = styled(Grid.Column)`
    padding-right: 1rem !important;
    padding-left: 0 !important;
    flex: 50 50 auto;
`;

const StyledTableLeft = styled(Grid.Column)`
    padding-left: 1rem !important;
    padding-right: 0 !important;
    flex: 50 50 auto;
`;

const StyledTableRow = styled(Table.Row)`
  cursor: pointer;
`;

const ScrollableTableWrapper = styled.div`
  height: 375px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  border: 1px solid rgba(34,36,38,.15);
  box-shadow: none;
  border-radius: .28571429rem;
  flex: 50 50 auto;

  & .ui.table {
    border: none;
  }

   & .ui.table thead tr:first-child > th {
      position: sticky !important;
      top: 0;
      z-index: 2;
      background: #fff;
  }

  & .ui.table tbody tr:last-child > td {
      border-bottom: 1px solid rgba(34,36,38,.15)
  }
`;

interface Props extends MessageSourceProps {
  epPrivileges?: Array<EpPrivilege>,
  selectedEpPrivileges?: Array<EpPrivilege>,
  availableEpPrivileges?: Array<EpPrivilege>,
  setSelectedEpPrivileges: (selectedEpPrivileges: Array<EpPrivilege>) => void
}

interface State {
  selectedAddEpPrivileges?: Array<EpPrivilege>,
  availableEpPrivileges?: Array<EpPrivilege>,
  markedEpPrivileges: Array<EpPrivilege>
}

class EpRolePrivilegesSegment extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const {selectedEpPrivileges = [], availableEpPrivileges = []} = this.props;

    this.state = {
      selectedAddEpPrivileges: selectedEpPrivileges,
      availableEpPrivileges: availableEpPrivileges,
      markedEpPrivileges: []
    };
  }

  epPrivilegeSelection = (epPrivilege: EpPrivilege) => {

    const {markedEpPrivileges, availableEpPrivileges = [], selectedAddEpPrivileges = []} = this.state;

    if (markedEpPrivileges.length === 0) {
      this.setState({
        markedEpPrivileges: [epPrivilege]
      })
    } else if (markedEpPrivileges.includes(epPrivilege)) {
      const filter = markedEpPrivileges.filter(priv => priv !== epPrivilege);

      this.setState({
        markedEpPrivileges: [...filter]
      })
    } else if (availableEpPrivileges.includes(epPrivilege)) {
      const filter = markedEpPrivileges.filter(priv => selectedAddEpPrivileges.includes(priv));

      if (filter.length > 0) {
        this.setState({
          markedEpPrivileges: [epPrivilege]
        })
      } else {
        this.setState({
          markedEpPrivileges: [...markedEpPrivileges, epPrivilege]
        })
      }
    } else {
      const filter = markedEpPrivileges.filter(priv => availableEpPrivileges.includes(priv));

      if (filter.length > 0) {
        this.setState({
          markedEpPrivileges: [epPrivilege]
        })
      } else {
        this.setState({
          markedEpPrivileges: [...markedEpPrivileges, epPrivilege]
        })
      }
    }
  };

  addRemoveEpPrivilege = () => {

    const {setSelectedEpPrivileges} = this.props;
    const {markedEpPrivileges = [], selectedAddEpPrivileges = [], availableEpPrivileges = []} = this.state;

    if (markedEpPrivileges.length > 0) {
      if (selectedAddEpPrivileges.some(priv => markedEpPrivileges.includes(priv))) {

        const filteredSelectedEpPrivileges = selectedAddEpPrivileges.filter(priv => !markedEpPrivileges.includes(priv));

        this.setState({
          availableEpPrivileges: [
            ...availableEpPrivileges,
            ...markedEpPrivileges
          ],
          selectedAddEpPrivileges: filteredSelectedEpPrivileges,
          markedEpPrivileges: []
        });

        setSelectedEpPrivileges(filteredSelectedEpPrivileges);
      } else {

        const filteredEpPrivileges = availableEpPrivileges.filter(priv => !markedEpPrivileges.includes(priv));
        const selectedEpPrivileges = [
          ...selectedAddEpPrivileges,
          ...markedEpPrivileges
        ];

        this.setState({
          selectedAddEpPrivileges: selectedEpPrivileges,
          availableEpPrivileges: filteredEpPrivileges,
          markedEpPrivileges: []
        });

        setSelectedEpPrivileges(selectedEpPrivileges);
      }
    }
  };

  markUnmarkAllEpPrivileges = (markEpPrivileges: Array<EpPrivilege>) => {
    this.setState({
      markedEpPrivileges: [...markEpPrivileges]
    })
  };

  render(): React.ReactNode {

    const {selectedAddEpPrivileges = [], availableEpPrivileges = [], markedEpPrivileges = []} = this.state;
    const {epPrivileges = [], getMessage} = this.props;

    const selectableEpPrivileges: Array<JSX.Element> = [];
    const usedEpPrivileges: Array<JSX.Element> = [];

    epPrivileges.forEach(priv => {

      const active = markedEpPrivileges.includes(priv);

      if (priv && availableEpPrivileges.includes(priv)) {

        const availableEpPrivilegeDescription = (
            <StyledTableRow key={priv}
                            onClick={() => this.epPrivilegeSelection(priv)}
                            active={active}
            >
              <Table.Cell>{getMessage(`epPrivilege.${priv}`)}</Table.Cell>
            </StyledTableRow>
        );

        selectableEpPrivileges.push(availableEpPrivilegeDescription)
      }

      if (priv && selectedAddEpPrivileges.includes(priv)) {

        const usedEpPrivilegeDescription = (
            <StyledTableRow key={priv}
                            onClick={() => this.epPrivilegeSelection(priv)}
                            active={active}
            >
              <Table.Cell>{getMessage(`epPrivilege.${priv}`)}</Table.Cell>
            </StyledTableRow>
        );

        usedEpPrivileges.push(usedEpPrivilegeDescription);
      }
    });

    const disabledLeft = markedEpPrivileges.length === 0 ||
        availableEpPrivileges.some(priv => markedEpPrivileges.includes(priv));
    const disabledRight = markedEpPrivileges.length === 0 ||
        selectedAddEpPrivileges.some(priv => markedEpPrivileges.includes(priv));

    return (
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Grid>
                <Grid.Row>
                  <StyledTableLeft>
                    {this.renderLeftTableSegment(getMessage("available"), selectableEpPrivileges)}
                  </StyledTableLeft>
                  <StyledButtons textAlign='center' verticalAlign='middle'>
                    <StyledBtnContainer>
                      <StyledIcon bordered
                                  onClick={() => this.markUnmarkAllEpPrivileges(availableEpPrivileges)}
                                  name='clipboard list'
                      />
                      <StyledIcon bordered
                                  onClick={() => this.markUnmarkAllEpPrivileges(selectedAddEpPrivileges)}
                                  name='clipboard list'
                      />
                    </StyledBtnContainer>
                    <StyledBtnContainer>
                      <StyledIcon bordered
                                  onClick={() => this.markUnmarkAllEpPrivileges([])}
                                  name='clipboard outline'
                      />
                      <StyledIcon bordered
                                  onClick={() => this.markUnmarkAllEpPrivileges([])}
                                  name='clipboard outline'
                      />
                    </StyledBtnContainer>
                    <StyledBtnContainer>
                      <StyledIcon bordered
                                  disabled={disabledRight}
                                  onClick={this.addRemoveEpPrivilege}
                                  name='angle double right'
                      />
                      <StyledIcon bordered
                                  disabled={disabledLeft}
                                  onClick={this.addRemoveEpPrivilege}
                                  name='angle double left'
                      />
                    </StyledBtnContainer>
                  </StyledButtons>
                  <StyledTableRight>
                    {this.renderRightTableSegment(getMessage("selected"), usedEpPrivileges)}
                  </StyledTableRight>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
    );
  }

  renderRightTableSegment = (headerText: string, usedEpPrivileges: Array<React.ReactNode>): React.ReactNode => {
    const {getMessage} = this.props;

    return (
        <React.Fragment>
          <Header as='h5'>
            {headerText}:
          </Header>
          <ScrollableTableWrapper>
            <Table celled selectable size='small'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>{getMessage("description")}</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {usedEpPrivileges}
              </Table.Body>
            </Table>
          </ScrollableTableWrapper>
        </React.Fragment>
    )
  };

  renderLeftTableSegment = (headerText: string, usedEpPrivileges: Array<React.ReactNode>): React.ReactNode => {
    const {getMessage} = this.props;

    return (
        <React.Fragment>
          <Header as='h5'>
            {headerText}:
          </Header>
          <ScrollableTableWrapper>
            <Table celled selectable size='small'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>{getMessage("description")}</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {usedEpPrivileges}
              </Table.Body>
            </Table>
          </ScrollableTableWrapper>
        </React.Fragment>
    )
  };

}

export default withMessages(EpRolePrivilegesSegment);
